import { Component, Input } from "@angular/core";
import { CdkDragDrop, moveItemInArray, transferArrayItem } from "@angular/cdk/drag-drop";
@Component({
    selector: "drag-and-drop-list",
    templateUrl: "./drag-and-drop-list.tmpl.html",
    styleUrls: ["./drag-and-drop-list.component.scss"],
    standalone: false
})
export class DragAndDropListComponent<T extends object = Record<string, unknown>>
{
    @Input() readonly groups: Array<Array<T>>;
    @Input() readonly groupTitles: Array<string>;
    @Input() readonly display: keyof T;
    @Input() readonly subtitleMember: keyof T;

    getDisplay(item: T): string
    {
        return item[this.display]?.toString();
    }

    getSubtitle(item: T): string
    {
        return item[this.subtitleMember]?.toString();
    }

    onCdkDropListDropped(event: CdkDragDrop<Array<T>>): void
    {
        if (event.previousContainer === event.container)
        {
            moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
        }
        else
        {
            transferArrayItem(
                event.previousContainer.data,
                event.container.data,
                event.previousIndex,
                event.currentIndex
            );
        }
    }
}
